<template>
  <div class="jd-dialog-cpn">
    <el-dialog :visible.sync="dialogVisible"
               custom-class="kf-dialog"
               @close="close"
               width="300px"
               height="436px">
      <div>
        当前账号已无余额，请充值后继续使用，如有任何疑问请<el-popover placement="bottom"
                    width="160"
                    trigger="hover"
                    content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
          <img v-if="$store.state.user.kfImgUrl"
               :src="$store.state.user.kfImgUrl"
               style="width: 160px;"
               alt="">
          <span slot="reference"
                style="text-decoration: underline;">联系客服</span>
        </el-popover>帮您解决
      </div>

    </el-dialog>
  </div>
</template>


<script>
import { getUserInfo } from '@/api/user'
export default {
  name: 'KfDialog',
  data() {
    return {}
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible() {
      return this.visible
    },
  },
  methods: {
    close() {
      getUserInfo().then((res) => {
        this.$store.dispatch('user/changeLoginInfo', res.result)
      })
      this.$emit('close')
      // window.location.reload()
    },
  },
  created() {},
}
</script>

<style lang="less">
.jd-dialog-cpn {
  line-height: 30px;
  border-radius: 32px !important;
  cursor: pointer;
  .el-dialog__body {
    padding: 30px 20px 40px 20px !important;
  }
  .el-icon-close:before {
    background-color: #ababab;
    border-radius: 50%;
    padding: 2px;
    color: #fff;
    font-weight: 800;
    font-size: 15px;
  }
}
</style>
